exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._6BtD {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 15px;\n}\n\n._3wx2 {\n    text-align: center;\n    margin-bottom: 10px;\n    color: #707172;\n}\n\n._2-ey {\n    max-width: 400px;\n    margin: 20px auto 10px auto;\n}\n\n._2c7Y {\n    margin-top: 10px;\n    font-size: 14px;\n}\n\n.W3Ih {\n    padding-bottom: 20px;\n    font-size: 16px;\n    color: #707172;\n}\n\n.mDpm {\n    text-align: center;\n    font-size: 14px;\n}\n\n._1aJX {\n    padding-bottom: 20px;\n}\n\n@media (max-width: 520px) {\n    .W3Ih {\n        padding: 10px 20px 20px 20px;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"body": "_6BtD",
	"registerInfo": "_3wx2",
	"header": "_2-ey",
	"loginText": "_2c7Y",
	"whySignUp": "W3Ih",
	"legalAgreement": "mDpm",
	"accessibilityLink": "_1aJX"
};